const faqItems = document.getElementsByClassName('faq-item');
if (faqItems)
{
    for (let faqItem of faqItems) {
        const expandableButton = faqItem.querySelector('.button--expandable');
        expandableButton?.addEventListener('click', () => {
            faqItem.classList.toggle('faq-item--expanded');
            expandableButton.querySelector('.expandable__icon')?.classList.toggle('expanded');
        });
    }
}